import React, { FC, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import routesByName from 'constants/routes';
import { AuthComponent, MainComponent } from 'modules';
import { GuestRoute, PrivateRoute, TimifyLoader } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { initAppAction } from 'modules/app/store/actions';
import { RootState } from 'store/rootReducer';

const App: FC = () => {
  const dispatch = useDispatch();
  const inited = useSelector((state: RootState) => state.app.inited);

  useEffect(() => {
    dispatch(initAppAction());
  }, [dispatch]);

  return inited ? (
    <Switch>
      <GuestRoute path={routesByName.auth.index}>
        <AuthComponent />
      </GuestRoute>
      <PrivateRoute path={routesByName.apps.index}>
        <MainComponent />
      </PrivateRoute>
    </Switch>
  ) : (
    <TimifyLoader fullHeight />
  );
};

export default App;
